import { Button, LuIcon } from "@overmap-ai/blocks"
import { Link } from "@tanstack/react-router"
import { memo } from "react"

import { modelIconMapping } from "../../mappings/icons"
import { BaseTopBar } from "../TopBars/BaseTopBar"

export const CreateIssueTypeViewTopBar = memo(() => {
	return (
		<BaseTopBar
			showAIButton={false}
			leftContent={
				<Link from="/$organizationId/settings/issue-types/create" to="/$organizationId/settings/issue-types">
					<Button variant="ghost" accentColor="base">
						<LuIcon icon={modelIconMapping.arrowLeft} />
						Issue types
					</Button>
				</Link>
			}
		/>
	)
})
CreateIssueTypeViewTopBar.displayName = "CreateIssueTypeViewTopBar"
